import {useQuery} from 'react-query'
import {useParams} from 'react-router-dom'
import {BASE_URL} from '../../config'
import axios from 'axios'
import {
  getTicketDetailsById,
  ITicketDetailsResponse,
  ITicketQueryDetails,
  ITicketQueryReplyResponse,
} from '../_model'
import CardSkeleton from '../../../utils/components/Skeleton/CardSkeleton'
import {KTIcon} from '../../../../_metronic/helpers'
import {dateFormat} from '../../../utils/helperFunction/_helper'
import {MediaViewer} from '../../../utils/components/MediaViewer'
import TicketReplyQueryForm from './TicketReplyQueryForm'

const GET_TICKET_QUERY_REPLY = `${BASE_URL}/api/protect/getTicketQuryWithReplyById?ticketId=`
const GET_TICKET_DETAILS_ID_URL = `${BASE_URL}/api/protect/getTicketDetailsById?ticketId=`

const TicketQueryDetails = () => {
  const {id: ticketId} = useParams()

  const {isLoading, data} = useQuery({
    queryKey: ['viewTicket'],
    queryFn: async () => {
      const [queryReplyRes, detailsRes] = await Promise.all([
        axios.get<ITicketQueryReplyResponse>(`${GET_TICKET_QUERY_REPLY}${ticketId}`),
        axios.get<ITicketDetailsResponse>(`${GET_TICKET_DETAILS_ID_URL}${ticketId}`),
      ])

      const result = await queryReplyRes.data

      return {
        details: detailsRes.data,
        queryReply: result.data,
      }
    },
    enabled: !!ticketId,
    refetchOnMount: true,
    cacheTime: 0,
    refetchOnWindowFocus: false,
  })

  let content

  if (isLoading) {
    content = (
      <div className='mt-5'>
        <CardSkeleton />
        <CardSkeleton />
      </div>
    )
  }

  if (data && !isLoading) {
    content = (
      <div className='card mt-5'>
        <div className='card-body w-100 mw-1000px'>
          <div className='d-flex gap-4'>
            <KTIcon iconName='file-up' className='fs-2hx text-success' />
            <div>
              <h3 className='fs-1 mb-0 d-flex gap-2'>
                {data.details.subject}
                <span className='badge badge-light-success fs-5'>{data.details.status}</span>
              </h3>
              <p className='text-gray-700 fs-5'>
                By: {data.details.user_name}
                {/* Created: {dateFormat(data.details.time, true)}{' '} */}
              </p>
              <p className='text-gray-700 fw-bold fs-2'>
                Assigned to:{' '}
                {data.details.assignedTo ? data.details.assignedTo : 'Not Assigned Yet'}
              </p>
            </div>
          </div>

          <div className='mt-10'>
            {data.queryReply.map((qr) => {
              if (!Object.keys(qr).length) return
              const {rid, user, message, isquery, attach, time} = qr
              const bg = isquery ? 'bg-primary' : 'bg-light'
              const titleClass = isquery ? 'fs-3 mb-1 text-gray-100' : 'fs-3 mb-1 text-gray-800'

              return (
                <div key={rid} className={`card mb-6 ${bg}`}>
                  <div className='card-body'>
                    <h3 className={`${titleClass} d-flex align-items-center`}>
                      By {user}
                      <span className='mx-2 badge badge-light-warning fs-6'>
                        {isquery ? 'Owner' : 'Supporter'}
                      </span>
                    </h3>
                    <span className={`fs-5 text-muted d-block mb-4`}>
                      at {dateFormat(time, true)}{' '}
                    </span>

                    <div className=''>
                      {/* <div className='fs-4'>{message}</div> */}
                      <div className='mb-5 fs-5' dangerouslySetInnerHTML={{__html: message!}}></div>

                      {attach ? (
                        <div className='mt-6'>
                          <h3 className={`${titleClass}`}>Attachment: </h3>
                          <div className='row'>
                            {attach.map((attachment, idx) => (
                              <div className='col-4' key={idx}>
                                <MediaViewer media={attachment} />
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>

          <div className='mt-20'>
            <TicketReplyQueryForm
              ticketId={parseInt(ticketId!)}
              assignedUserId={data.details.assignedToId}
            />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <h2>View Ticket</h2>
      {content}
    </div>
  )
}

export default TicketQueryDetails
